import Menu from './Menu';
import Exports from './Exports';
import Sales from './SalesReport';
import FFDAReports from './FFDAReports';

export default {
    Menu,
    FFDAReports,
    Exports,
    Sales,
};
